import { GatsbyImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import React from 'react'
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { CarouselWrapper } from './styles'

const ImageCarousel = ({ images, infiniteLoop = true }) => {
  return (
    <CarouselWrapper>
      <Carousel
        showIndicators={images.length > 1}
        showStatus={false}
        showArrows={false}
        showThumbs={false}
        autoPlay={false}
        infiniteLoop={infiniteLoop && images.length > 1}
      >
        {images.map((image, index) => (
          <GatsbyImage
            image={image.gatsbyImageData}
            key={index}
            alt={image.description}
            loading={index === 0 ? 'eager' : 'lazy'}
          />
        ))}
      </Carousel>
    </CarouselWrapper>
  )
}

ImageCarousel.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  infiniteLoop: PropTypes.bool,
}

export default ImageCarousel
